/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Descriptions,
  Button,
  Space,
  message,
  Image,
  Spin,
  Modal,
} from "antd";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewRTOShipmentDetails.scss";
import Heading from "../../../components/Heading";
import moment from "moment";
import { getUserAndPremiseId } from "../../../utils";
import API from "../../../api";
import urls from "../../../api/urls";
import Smcs_Loader from "../../../assests/images/loader-new.gif";

const {
  UNDELIVERED_SHIPMENT_DETAILS,
  UPDATE_RTO_STATUS,
  RTO_REQUEST_REJECT,
  RTO_REQUEST_APPROVE,
} = urls;

const ViewRTOShipmentDetails = () => {
  const [loading, setLoading] = useState(false);
  const [shipmentData, setShipmentData] = useState(null);
  const { id, isRTOShipment = false } = useParams();
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetchShipmentDetails(id);
  }, [id]);

  const fetchShipmentDetails = async (id) => {
    setLoading(true);
    try {
      let url = `${UNDELIVERED_SHIPMENT_DETAILS}${id}`;
      let response = await API.Api(url).getWithUserNPremiseHeader();

      if (response?.status) {
        const orderData = response?.response?.data?.data || null;
        setShipmentData(orderData);
      } else {
        message.error(
          response?.response?.data?.message ||
          "Failed to fetch shipment details."
        );
      }
    } catch (error) {
      console.error("Error fetching shipment details:", error);
      message.error("An error occurred while fetching shipment details.");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleCopyPRSNumber = () => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        message.success("AWB Number Copied To Clipboard");
      })
      .catch((err) => {
        message.error("Failed to copy AWB number");
      });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("MM/DD/YYYY hh:mm A");
  };

  const handleViewImages = () => {
    // Dummy images array
    const dummyImages = [
      "https://gw.alipayobjects.com/zos/antfincdn/x43I27A55%26/photo-1438109491414-7198515b166b.webp", // Replace with actual image URLs
      "https://gw.alipayobjects.com/zos/antfincdn/cV16ZqzMjW/photo-1473091540282-9b846e7965e3.webp",
      "https://gw.alipayobjects.com/zos/antfincdn/LlvErxo8H9/photo-1503185912284-5271ff81b9a8.webp",
    ];
    setImages(dummyImages);
    setVisible(true);
  };

  const handleRequestRTO = () => {
    Modal.confirm({
      title: "Confirm RTO Request",
      content: `Are you sure you want to request RTO for AWB: ${shipmentData?.awbNumber || id
        }?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => requestForRTO(),
      centered: true,
      maskClosable: true,
    });
  };

  const requestForRTO = async () => {
    const awbNumber = shipmentData?.awbNumber || id;
    const deliveryPartners =
      JSON.parse(sessionStorage.getItem("deliveryPartner"))?.data || [];
    const dpId =
      deliveryPartners.length > 0 ? deliveryPartners[0]?.dpId : "";

    try {
      setLoading(true);
      await API.Api(
        `${urls.SUPERVISOR_RTO_REQUEST}?awbNumber=${awbNumber}&dpId=${dpId}`
      ).patch();
      message.success("RTO request submitted successfully");
      fetchShipmentDetails(id);
    } catch (error) {
      console.error("Error requesting RTO:", error);
      message.error(
        error?.response?.data?.message || "Failed to submit RTO request"
      );
    } finally {
      setLoading(false);
    }
  };

  const getFieldValue = (field, defaultValue = "-") => {
    if (!shipmentData) return defaultValue;

    switch (field) {
      case "awbNumber":
        return shipmentData?.awbNumber || id || defaultValue;
      case "status":
        return shipmentData?.status || "N/A";
      case "bookingDate":
        return (
          formatDateTime(shipmentData?.shippingDetails?.createdDate) ||
          defaultValue
        );
      case "attemptDate":
        return (
          formatDateTime(shipmentData?.rtoDetails?.deliveryAttemptedOn) ||
          defaultValue
        );
      case "reason":
        return shipmentData?.rtoDetails?.reasonForNonDelivery || defaultValue;
      case "daName":
        return shipmentData?.rtoDetails?.daName || defaultValue;
      case "daMobile":
        return shipmentData?.rtoDetails?.["damobileno."] || defaultValue;
      case "daId":
        return shipmentData?.rtoDetails?.deliveryAgentId || defaultValue;
      case "customerName":
        return shipmentData?.shippingDetails?.name || defaultValue;
      case "customerMobile":
        return shipmentData?.shippingDetails?.phone || defaultValue;
      case "customerAddress":
        if (shipmentData?.shippingDetails) {
          const { address1, city, state, zip } =
            shipmentData?.shippingDetails || {};
          return `${address1 || ""}, ${city || ""}, ${state || ""} - ${zip || ""
            }`;
        }
        return defaultValue;
      case "sellerName":
        return shipmentData?.pickupDetails?.name || defaultValue;
      case "sellerMobile":
        return shipmentData?.pickupDetails?.phone || defaultValue;
      case "pickupAddress":
        if (shipmentData?.pickupDetails) {
          const { address1, city, state, zip } =
            shipmentData?.pickupDetails || {};
          return `${address1 || ""}, ${city || ""}, ${state || ""} - ${zip || ""
            }`;
        }
        return defaultValue;
      case "rtoRequestedAt":
        return formatDateTime(shipmentData?.rtoRequestedAt) || defaultValue;
      case "damobileno":
        return shipmentData?.rtoDetails?.["damobileno."] || defaultValue;
      case "reasonForNonDelivery":
        return shipmentData?.rtoDetails?.reasonForNonDelivery || defaultValue;
      case "deliveryAgentId":
        return shipmentData?.rtoDetails?.deliveryAgentId || defaultValue;
      case "hubName":
        return shipmentData?.hubName || defaultValue;
      case "contactPersonName":
        return shipmentData?.contactPersonName || defaultValue;
      case "contactPersonPhone":
        return shipmentData?.contactPersonPhone || defaultValue;
      default:
        return defaultValue;
    }
  };

  const handleRejectRTO = async () => {
    setLoading(true);
    try {
      const payload = {
        awbNumbers: [shipmentData?.awbNumber] || id,
      };

      const response = await API.Api(RTO_REQUEST_REJECT).post(payload);

      if (response?.status) {
        message.success("RTO request rejected successfully");
        // Refresh shipment details to show updated status
        fetchShipmentDetails(id);
      } else {
        message.error(
          response?.response?.data?.message ||
          response?.response?.statusText ||
          "Failed to reject RTO request."
        );
      }
    } catch (error) {
      console.error("Error rejecting RTO request:", error);
      message.error("An error occurred while rejecting RTO request.");
    } finally {
      setLoading(false);
    }
  };

  const handleApproveRTO = async () => {
    setLoading(true);
    try {
      const userInfo = getUserAndPremiseId();
      const userName = `${userInfo?.firstName || ""} ${userInfo?.lastName || ""
        }`.trim();

      const userData = JSON.parse(sessionStorage.getItem("userId") || localStorage.getItem("userId"));
      const premiseName = userData?.premises?.premiseName || "";

      const payload = {
        awbNumbers: [shipmentData?.awbNumber] || id,
        userName: userName,
        premiseName: premiseName,
      };

      const response = await API.Api(RTO_REQUEST_APPROVE).post(payload);

      if (response?.status) {
        message.success("RTO request approved successfully");
        // Refresh shipment details to show updated status
        fetchShipmentDetails(id);
      } else {
        message.error(
          response?.response?.data?.message ||
          response?.response?.statusText ||
          "Failed to approve RTO request."
        );
      }
    } catch (error) {
      console.error("Error approving RTO request:", error);
      message.error("An error occurred while approving RTO request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="shipment-details-container">
        <Heading title="Shipment Details" />
        <div className="prs-details">
          <Row>
            <div className="prs-primary-details-row">
              <div className="box-left">
                <div className="prs-number-status">
                  <div
                    className="prs-number-container"
                    onClick={handleCopyPRSNumber}
                    style={{ cursor: "context-menu" }}
                  >
                    {getFieldValue("awbNumber")}
                  </div>
                  <div className="prs-status-container">
                    {getFieldValue("status")}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1em",
                    flexWrap: "wrap",
                  }}
                  className="prs-other-details-container"
                >
                  <div style={{ flex: 1, minWidth: "250px" }}>
                    <p
                      style={{
                        color: "#666",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Booking Date: &nbsp;&nbsp;&nbsp;
                      <span className="highlight">
                        {getFieldValue("bookingDate")}
                      </span>
                    </p>
                  </div>
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1em",
                    flexWrap: "wrap",
                  }}
                  className="prs-other-details-container"
                >
                  <div style={{ flex: 1, minWidth: "250px" }}>
                    <p style={{
                      color: "#666",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center"
                    }}>
                      RTO Request Status:
                      <span style={{
                        color: "#F08C00",
                        marginLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}>
                        Pending
                      </span>
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          </Row>
          <Row>
            <div className="card-title">RTO Request Details</div>
            <div className="prs-secondary-details-row">
              <div className="details-box">
                <div className="detail-label">RTO Request Received On</div>
                <div className="detail-value">
                  {getFieldValue("rtoRequestedAt")}
                </div>
              </div>
              <div className="details-box">
                <div className="detail-label">Hub Name</div>
                <div className="detail-value">{getFieldValue("hubName")}</div>
              </div>
              <div className="details-box">
                <div className="detail-label">Supervisor Name</div>
                <div className="detail-value">{getFieldValue("contactPersonName")}</div>
              </div>
              <div className="details-box">
                <div className="detail-label">Supervisor Mobile no.</div>
                <div className="detail-value">{getFieldValue("contactPersonPhone")}</div>
              </div>
            </div>
          </Row>
          <Row>
            <div className="card-title">Delivery Attempt Details</div>
            <div className="prs-secondary-details-row">
              <div className="details-box">
                <div className="detail-label">Delivery Attempted On</div>
                <div className="detail-value">
                  {getFieldValue("attemptDate")}
                </div>
              </div>
              <div className="details-box">
                <div className="detail-label">Reason for Non Delivery</div>
                <div className="detail-value">{getFieldValue("reason")}</div>
              </div>
              <div className="details-box">
                {/* <div className="detail-label">Proof of Non Delivery</div>
            <div className="detail-value">
              <a onClick={handleViewImages}>View Images</a>
            </div> */}
              </div>
            </div>
          </Row>
          <Row>
            <div className="card-title">DA Details</div>
            <div className="prs-secondary-details-row">
              <div className="details-box">
                <div className="detail-label">DA Name</div>
                <div className="detail-value">{getFieldValue("daName")}</div>
              </div>
              <div className="details-box">
                <div className="detail-label">DA Mobile Number</div>
                <div className="detail-value">{getFieldValue("daMobile")}</div>
              </div>
              <div className="details-box">
                <div className="detail-label">DA ID</div>
                <div className="detail-value">{getFieldValue("daId")}</div>
              </div>
              <div className="details-box">
                <div className="detail-label">DA Username</div>
                <div className="detail-value">{getFieldValue("daName")}</div>
              </div>
            </div>
          </Row>
          <Row>
            <div className="card-title">Customer Details</div>
            <div className="prs-secondary-details-row">
              <div className="details-box">
                <div className="detail-label">Customer Name</div>
                <div className="detail-value">
                  {getFieldValue("customerName")}
                </div>
              </div>
              <div className="details-box">
                <div className="detail-label">Customer Mobile no.</div>
                <div className="detail-value">
                  {getFieldValue("customerMobile")}
                </div>
              </div>
              <div className="details-box">
                <div className="detail-label">Delivery Address</div>
                <div className="detail-value">
                  {getFieldValue("customerAddress")}
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <div className="card-title">Seller Details</div>
            <div className="prs-secondary-details-row">
              <div className="details-box">
                <div className="detail-label">Seller Name</div>
                <div className="detail-value">
                  {getFieldValue("sellerName")}
                </div>
              </div>
              <div className="details-box">
                <div className="detail-label">Seller Mobile no.</div>
                <div className="detail-value">
                  {getFieldValue("sellerMobile")}
                </div>
              </div>
              <div className="details-box">
                <div className="detail-label">Pickup Address</div>
                <div className="detail-value">
                  {getFieldValue("pickupAddress")}
                </div>
              </div>
            </div>
          </Row>

          {getFieldValue("status") === "RTO_REQUESTED" && (
            <Row
              justify="end"
              style={{
                borderTop: "1px solid #DEDEDE",
                padding: "16px",
                marginTop: "16px",
              }}
            >
              <Space>
                <Button onClick={handleBack}>BACK</Button>
                <Button
                  type="primary"
                  onClick={handleRejectRTO}
                  style={{ backgroundColor: "#D02E2E", borderColor: "#D02E2E" }}
                >
                  REJECT RTO
                </Button>
                <Button type="primary" onClick={handleApproveRTO}>
                  APPROVE RTO
                </Button>
              </Space>
            </Row>
          )}

          <div style={{ display: "none" }}>
            <Image.PreviewGroup
              preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
            >
              {images.map((image, index) => (
                <Image key={index} src={image} width={200} />
              ))}
            </Image.PreviewGroup>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ViewRTOShipmentDetails;
